// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s9Hz","index":"styles_index__3HtMF"};